import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from '../../auth/Auth';

interface UserProfile {
  firstName: string;
  lastName: string;
}

interface UserProfileContextType {
  userProfile: UserProfile;
  setUserProfile: React.Dispatch<React.SetStateAction<UserProfile>>;
}

const UserProfileContext = createContext<UserProfileContextType | undefined>(undefined);

export const UserProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser } = useAuth();
  const [userProfile, setUserProfile] = useState<UserProfile>({
    firstName: '',
    lastName: '',
  });
  useEffect(() => {
    if (currentUser?.user?.firstName || currentUser?.user?.lastName) {
      setUserProfile({
        firstName: currentUser.user.firstName || '',
        lastName: currentUser.user.lastName || '',
      });
    }
  }, [currentUser?.user?.firstName, currentUser?.user?.lastName]);
  return (
    <UserProfileContext.Provider value={{ userProfile, setUserProfile }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => {
  const context = useContext(UserProfileContext);
  if (context === undefined) {
    throw new Error('useUserProfile must be used within a UserProfileProvider');
  }
  return context;
};
